<template>
    <PopupRouterView :showLeftIcon="true" label="Outgoing Check Input"
        okTitle="Save"
        cancelTitle="Cancel"
        entityName="outgoingcheck"
        :documentId="mainRecordId"
        @saveMethod="saveAction"
        @hideMethod="onHidden"
        ref="outgoingCheckInput"
        modalClass="input-scan-page">

        <template #modal-header-left-button>
			<span class="mr-1 d-sm-flex d-md-none">
                <b-button size="sm" class="ml-1 btn-back " @click="$router.back()"><b-icon-arrow-left /></b-button>
			</span>
		</template>

        <div class="p-2">
			<span v-if="scanPageIndex == 1">
				<b-row>
					<b-col cols="12">
						<!-- <app-label label-cols-lg="12" size="sm" type="generatednumber" label="Outgoing Check Number" :model="model.outgoingCheckNumber" /> -->
						<!-- <app-input-combobox-autocomplete :options="deliveryInstructions" optionsLabel="diNumber" optionsKey="id" label-cols-lg="12" label="Delivery Instruction" id="fieldset-delivery-instruction-number" size="lg" :model.sync="selectedDeliveryInstruction.id" :selected="selectedDeliveryInstruction!=null ? selectedDeliveryInstruction.diNumber:''" @input="getDeliveryInstructions" :isSelectMethodExists="true" @onSelectMethod="setSelectedOutgoingCheck"/> -->
						<app-input-scan id="fieldset-delivery-instruction-number" ref="fieldset-delivery-instruction-number" :model.sync="deliveryInstructionQrCode" label="Delivery Instruction" @scannedMethod="scanDeliveryInstruction" :isBusy="isScanDeliveryInstructionLoading" autofocus />
					</b-col>
				</b-row> 
				<b-row>
					<b-col cols="12">
						<span v-if="deliveryInstructions != null && deliveryInstructions.length > 0">
							<app-list :isDataLoading="isDeliveryInstructionDeliveryInstructionsLoading" :dataCount="deliveryInstructions.length">
								<delivery-instruction-item v-for="(item,index) in deliveryInstructions" :model="item" :key="index" @nextAction="scanDeliveryInstruction(item.diNumber)" />
							</app-list>
						</span>
					</b-col>
				</b-row>
			</span>
			<span v-if="scanPageIndex == 2">
				<b-row>
					<b-col cols="12">
						<app-label label-cols-lg="12" size="sm" label="Delivery Instruction" :model="model.deliveryInstruction!= null ? model.deliveryInstruction.diNumber:''" />
						<app-input-scan id="fieldset-part" ref="fieldset-part" :model.sync="partNumberQrCode" label="Part Number" @scannedMethod="scanPart" :isBusy="isScanPartLoading" autofocus />
						<!-- <app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" label-cols-sm="12" label="Part" id="fieldset-part" size="sm" :model.sync="selectedpartId" :selected="part!=null ? part.partNumber : ''" @input="getParts" :isSelectMethodExists="true" @onSelectMethod="setSelectedPart"/> -->
						<!-- <app-input-scan id="fieldset-delivery-instruction" ref="fieldset-delivery-instruction" :model.sync="deliveryInstructionQrCode" label="Delivery Instruction" @scannedMethod="scanDeliveryInstruction" :isBusy="isScanDeliveryInstructionLoading" autofocus /> -->
					</b-col>
				</b-row>
				<b-row>
					<b-col cols="12">
						<span v-if="parts != null && parts.length > 0">
							<app-list :isDataLoading="isPartComboLoading" :dataCount="parts.length">
								<part-item v-for="(item,index) in parts" :model="item" :key="index" @nextAction="scanPart(item.partNumber)" />
							</app-list>
						</span>
					</b-col>
				</b-row>
			</span>
			<span v-if="scanPageIndex == 3">
				<b-row>
					<b-col cols="12">
						<app-label label-cols-lg="12" size="sm" label="Delivery Instruction" :model="model.deliveryInstruction.diNumber" />
						<app-label label-cols-lg="12" size="sm" label="Part Number" :model="selectedOutgoingCheckDetail.part.partNumber" />
						<app-label label-cols-lg="12" size="sm" label="Part Name" :model="selectedOutgoingCheckDetail.part.partName" />
						<app-label label-cols-lg="12" size="sm" label="Delivery Qty" :model="selectedOutgoingCheckDetail.deliveryQty" />
						<div class="custom-table">
							<b-row class="button-container">
								<b-col cols="4" class="button-container">
									<b-button variant="primary" class="small-btn" @click="toggleChecks">{{ buttonText }}</b-button>
								</b-col>
							</b-row>
							<b-row class="content">
								<b-col cols="8" class="text-center">Case Number</b-col>
								<b-col cols="4" class="checkbox-container text-center">Action</b-col>
							</b-row>
							<b-row class="content" v-for="(item, index) in deliveryCards" :key="index">
								<b-col cols="8" class="card-number">{{ item.deliveryCardNumber }}</b-col>
								<b-col cols="4" class="checkbox-container">
									<b-form-checkbox :id="'input-checked-' + index" v-model="item.isLoading"></b-form-checkbox>
								</b-col>
							</b-row>
						</div>
					</b-col>
				</b-row>
			</span>
			<span v-if="scanPageIndex == 4">
				<b-row>
					<b-col cols="12">
						<app-label v-if="parentValueInfo != undefined && parentValueInfo != null && parentValueInfo != ''" label-cols-lg="12" size="sm" :label="parentLabelInfo" :model="parentValueInfo" />
						<app-input-scan id="fieldset-delivery-instruction-detail" ref="fieldset-delivery-instruction-detail" :model.sync="deliveryInstructionDetailQrCode" label="Delivery Instruction Detail" @scannedMethod="scanDeliveryInstructionDetail" :isBusy="isScanDeliveryInstructionDetailLoading" autofocus />
					</b-col>
				</b-row>
				<b-row>
					<b-col cols="12">
						<span v-if="outgoingCheckDetails != null && outgoingCheckDetails.length > 0">
							<app-list :isDataLoading="isDeliveryInstructionDetailDeliveryInstructionDetailsLoading" :dataCount="outgoingCheckDetails.length">
								<outgoing-check-detail-item v-for="(item,index) in outgoingCheckDetails" :model="item" :key="index" @nextAction="goToNext(5, item)" :isDisabled="checkIsDeliveryInstructionDetailDisabled(item)"/>
							</app-list>
						</span>
					</b-col>
				</b-row>
				<b-row>
					<b-col cols="12">
						<span v-if="outgoingCheckDetailsFiltered != null && outgoingCheckDetailsFiltered.length > 0">
							<app-table-input
								title="Outgoing Check Detail"
								:bordered="true"
								:items="outgoingCheckDetailsFiltered"
								:fields="fieldsOutgoingCheckDetail"
								:busy="isDataLoading"
								:sort-by.sync="sortByOutgoingCheckDetail"
								:sort-desc.sync="sortDescOutgoingCheckDetail" small responsive
								:showActionButton="false"
								:showDeleteButton="false"
								:showAddButton="false"
								:showAddFromClipboardButton="false"
								:showReplaceFromClipboardButton="false"
								:showUploadButton="false"
								:showDownloadButton="false"
								:isDownloadBusy="isDownloadOutgoingCheckDetail"
							/>
						</span>

					</b-col>
				</b-row>
			</span>

        </div>


        <b-overlay :show="isBusy" no-wrap></b-overlay>
        <template #modal-action-button>
			<!-- <b-button size="sm" variant="success" @click="pagePreview(true)">View Next</b-button> -->
			<b-button v-if="scanPageIndex != 1 && scanPageIndex != 4" size="sm" class="btn-fill-success float-right mr-1" @click="pagePreview(false)">Back</b-button>
			<b-button v-if="scanPageIndex == 2" size="sm" class="btn-fill-success float-right" @click="printPdfCustom"><b-icon-printer></b-icon-printer> Print List</b-button>
			<b-button v-if="scanPageIndex == 3" size="sm" class="btn-fill-success float-right" @click="finishCheckSheet" :disabled="!allChecked">Finish</b-button>
			<!-- <b-button v-if="scanPageIndex == 1" size="sm" class="btn-fill-success float-right" @click="goToNext(2)">Next</b-button>
			<b-button v-if="scanPageIndex == 4" size="sm" class="btn-fill-success float-right" @click="saveAction()">Finish</b-button> -->
        </template>
		<OutgoingCheckDetailScan
			:parentLabelInfo="parentLabelInfo"
			:parentValueInfo="parentValueInfo"
			:model="modelOutgoingCheckDetail"
			:modelId="outgoingCheckDetailId"
			:openPopup="isShowPopupOutgoingCheckDetail"
			@resetMethod="resetModal"
			@addButtonMethod="addRowDataOutgoingCheckDetail"/>

		<PopupPDF :openPopup="isShowPopUpPdf" :pdfUrl="pdfUrl" @resetModalMethod="resetModal" label="Print Delivery Instruction" />


    </PopupRouterView>
</template>

<style scoped>
	.button-container {
		display: flex;
		justify-content: flex-end;
		margin-bottom: 10px;
	}
	.checkbox-container {
		display: flex;
		justify-content: center;
	}
	.content {
		padding: 10px;
	}
	.card-number {
		font-size: 22px;
		color: rgb(102, 203, 250);
	}
	.small-btn {
		font-size: 0.8rem !important;
	}
</style>

<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import toast from '@/mixins/toastMixin';
import focusInput from '@/mixins/focusInputMixin';
import AppInputScan from '@/components/AppInputScan';
import AppList from '@/components/AppList';
import OutgoingCheck from '@/models/OutgoingCheck/OutgoingCheck';
import OutgoingCheckList from '@/models/OutgoingCheck/OutgoingCheckList';
import OutgoingCheckFilter from '@/filters/OutgoingCheck/OutgoingCheckFilter';
import DeliveryInstructionItem from './components/DeliveryInstructionItem';
import OutgoingCheckDetailItem from './components/OutgoingCheckDetailItem';
import PartItem from './components/PartItem';
import AppLabel from '@/components/AppLabel';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import DeliveryInstruction from '@/models/DeliveryInstruction/DeliveryInstruction';
import DeliveryInstructionFilter from '@/filters/DeliveryInstruction/DeliveryInstructionFilter';
import DeliveryInstructionDeliveryCard from '@/models/DeliveryInstructionDeliveryCard/DeliveryInstructionDeliveryCard';
import DeliveryInstructionDeliveryCardFilter from '@/filters/DeliveryInstructionDeliveryCard/DeliveryInstructionDeliveryCardFilter';
import UserInfo from '@/models/UserInfo/UserInfo';
import UserInfoFilter from '@/filters/UserInfo/UserInfoFilter';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
import OutgoingCheckStatus from '@/models/OutgoingCheckStatus/OutgoingCheckStatus';
import OutgoingCheckStatusFilter from '@/filters/OutgoingCheckStatus/OutgoingCheckStatusFilter';
import OutgoingCheckDetail from '@/models/OutgoingCheck/OutgoingCheckDetail';
import OutgoingCheckDetailFilter from '@/filters/OutgoingCheck/OutgoingCheckDetailFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import DeliveryInstructionDetail from '@/models/DeliveryInstruction/DeliveryInstructionDetail';
import DeliveryInstructionDetailFilter from '@/filters/DeliveryInstruction/DeliveryInstructionDetailFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppInputCheckbox from '@/components/AppInputCheckbox';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import OutgoingCheckDetailInput from '@/views/OutgoingCheck/OutgoingCheckDetailInput';
import OutgoingCheckDetailScan from '@/views/OutgoingCheck/OutgoingCheckDetailScan';
import OutgoingCheckDetailUpload from '@/views/OutgoingCheck/OutgoingCheckDetailUpload';
import PopupRouterView from '@/components/PopupRouterView';
import PopupPDF from '@/components/PopupPDF';
export default {
	components : {
		AppLabel,
		AppInputComboboxAutocomplete,
		AppInputDatetimepicker,
		AppInputDatetimepickerRange,
		AppInputTextbox,
		AppInputCheckbox,
		OutgoingCheckDetailInput,
		OutgoingCheckDetailScan,
		OutgoingCheckDetailUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterView,
		AppInputScan,
		AppList,
		DeliveryInstructionItem,
		OutgoingCheckDetailItem,
		PartItem,
		PopupPDF
	},
	mixins : [validationMixin, toast, focusInput],
	validations: {
		model: {
		},
	},
	data() {
		return {
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldsOutgoingCheckDetail: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"name": { "class" : "th-name first-child", "label" : "Name", key: 'name', sortable: false}}, 
				{"deliveryInstructionDetail": { "class" : "th-delivery-instruction-detail", "label" : "Delivery Instruction Detail", key: 'deliveryInstructionDetail.part', sortable: false}}, 
				{"part": { "class" : "th-part last-child", "label" : "Part", key: 'part.partNumber', sortable: false}}, 
				{"deliveryQty": { "class" : "th-delivery-qty d-stack-none", "label" : "Delivery Qty", key: 'deliveryQty', sortable: false}}, 
				{"isCompleted": { "class" : "th-is-completed d-stack-none", "label" : "Is Completed", key: 'isCompleted', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelOutgoingCheckDetail : {},
			isShowPopupOutgoingCheckDetail : false,
			isShowPopupUploadOutgoingCheckDetail : false,
			isShowPopupOutgoingCheckDetailScan : false,
			filterOutgoingCheck : null,
			currentOutgoingCheckPage : 1,
			outgoingCheckPageSize: 10,
			sortByOutgoingCheck: '',
			sortDescOutgoingCheck: '',
			filterOutgoingCheckDetail : null,
			currentOutgoingCheckDetailPage : 1,
			outgoingCheckDetailPageSize: 10,
			sortByOutgoingCheckDetail: '',
			sortDescOutgoingCheckDetail: '',
			sortingByOutgoingCheckDetail: [],
			outgoingCheckDetails : [],
			outgoingCheckDetailId : '',
			totalOutgoingCheckDetailRow : 0,
			isShowOutgoingCheckDetailFilter: false,
			isDownloadOutgoingCheckDetail: false,
			deliveryInstructionDetails: [],
			parts: [],
			deliveryInstructions: [],
			isDeliveryInstructionComboLoading: false,
			userInfos: [],
			processBys: [],
			isProcessByComboLoading: false,
			outgoingChecks: [],
			outgoingCheckStatuss: [],
			isOutgoingCheckStatusComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isUserInfoComboLoading: false,
			isOutgoingCheckComboLoading: false,
			isDeliveryInstructionDetailComboLoading: false,
			isPartComboLoading: false,
			scanPageIndex: 1,
			parentLabelInfo: '',
			parentValueInfo: '',
			deliveryInstructionQrCode: '',
			isScanDeliveryInstructionLoading: false,
			isDeliveryInstructionDeliveryInstructionsLoading: false,
			deliveryInstructionDeliveryInstructions: [],
			deliveryInstructionsFiltered: [],
			deliveryInstructionDetailQrCode: '',
			isScanDeliveryInstructionDetailLoading: false,
			isDeliveryInstructionDetailDeliveryInstructionDetailsLoading: false,
			deliveryInstructionDetailDeliveryInstructionDetails: [],
			outgoingCheckDetailsFiltered: [],
			part: null,
			selectedpartId:'',
			selectedDeliveryInstruction: {},
			selectedOutgoingCheckDetail: {},
			deliveryCards: [],
			buttonText: "Check All",
			testCheck: true,
			allChecked: false,
			isShowPopUpPdf: false,
			pdfUrl: '',
			partNumberQrCode: '',
			isScanPartLoading: false,
		}
	},
	methods : {
		printPdfCustom: async function() {
			this.isBusy = true;
			let id = this.model.deliveryInstructionId;
			console.log(id);
			let result = await this.$http.get('OutgoingCheck/printdeliveryinstruction/'+id)
			.then(async function (response) {
				if (response.data) {
					return response.data
				}
			})
			.catch(function (error) {
				let errors = error.response.data.errors['1']
				this.toast({message: errors[0], title: 'System Error', variant: 'danger', autoHideDelay: 3000})
				this.isBusy = false;
			});
			this.isBusy = false;
			this.isShowPopUpPdf = true;
			this.pdfUrl = result.download;
		},
		toggleChecks() {
			console.log(this.deliveryCards);
			if(this.deliveryCards.every(item => item.isLoading == true) || this.deliveryCards.every(item => item.isLoading == false)) {
				this.deliveryCards.forEach(item => {
					item.isLoading = !item.isLoading;
				});
			} else {
				this.deliveryCards.forEach(item => {
					item.isLoading = true
				});
			}

			if(this.deliveryCards.every(item => item.isLoading == true)) {
				this.allChecked = true;
				this.buttonText = "Uncheck All";
			} else {
				this.buttonText = "Check All";
				this.allChecked = false;
			}

		},
		getParts : async function(input) {
			try {
				let id = this.modelId;
				if(input == undefined || input == null) {
					input = '';
				}
				const response = await this.$http.get(`OutgoingCheck/getpartforoutgoingcheckdetails/${id}?partNumber=${input}`);
				if(response.data != null) {
					this.parts = response.data;
				}
			} catch(error) {
				let errors = error.response.data.errors['1']
				this.toast({message: errors[0], title: 'System Error', variant: 'danger', autoHideDelay: 3000})
			}
		},
		async finishCheckSheet(input) {
			try {

				let checkedIds = this.deliveryCards.filter(card => card.isLoading).map(card => card.id);

				const response = await this.$http.post(`OutgoingCheck/finishchecksheet/${this.model.id}/${this.selectedOutgoingCheckDetail.id}`, checkedIds);
				console.log(response);
				if (response.data !== null) {
					const result = response.data;
					if (result.isComplete) {
						this.model = {},
						await this.getOutgoingChecks();
						await this.getDeliveryInstructions();
						this.goToNext(1);
					} else {
						await this.getOutgoingCheck(this.model.id);
						await this.getParts();
						this.goToNext(2);
					}
					return;
				}
			} catch (error) {
				let errors = error.response.data.errors['1']
				this.toast({message: errors[0], title: 'System Error', variant: 'danger', autoHideDelay: 3000})
			}
		},
		getDeliveryInstructions : async function(input) {
			try {
				if(input == undefined || input == null) {
					input = '';
				}
				const response = await this.$http.get(`OutgoingCheck/getdeliveryinstructions/?dinumber=${input}`);
				if(response.data != null) {
					this.deliveryInstructions = response.data;
				}
			} catch(error) {
				// this.$store.dispatch('addErrorMessageGlobal', error);
				// throw error;
			}
		},
		async setSelectedPart(item) {
			let partId = item.id;
			this.selectedOutgoingCheckDetail = this.model.outgoingCheckDetail.find(item => item.partId == partId);
			console.log("detail", this.selectedOutgoingCheckDetail);
			this.goToNext(3);
		},
		async scanPart(partNumber) {
			console.log("partNumber", partNumber);
			if(partNumber) this.partNumberQrCode = partNumber;

			console.log("partQrCode", this.partNumberQrCode);
			console.log("parts", this.parts);
			let part = this.parts.find(part => part.partNumber == this.partNumberQrCode);
			console.log("selected part", part);
			if(part == null || part == undefined) {
				let error = `Part dengan Part Number ${this.partNumberQrCode} tidak ditemukan`
				this.partNumberQrCode = '';
				this.toast({message: error, title: 'System Error', variant: 'danger', autoHideDelay: 3000})
				this.$nextTick(() => {
					this.focusInput(this, "fieldset-part");
				});

				return;
			}

			this.partNumberQrCode = '';
			await this.setSelectedPart(part);
			return;
		},
		async scanDeliveryInstruction(qrFromList) {
			try {
				if(qrFromList) this.deliveryInstructionQrCode = qrFromList;
				let id = this.model.id;
				
				const response = await this.$http.get(`OutgoingCheck/scanDeliveryInstruction/${id}?diNumber=${this.deliveryInstructionQrCode}`);
				if(response && response.data) {
					//let item = response.data;

					let data = response.data;
					console.log("data", data);
					console.log("model id", this.modelId);
					if(data.id != this.modelId) {
						this.$router.replace('/outgoingcheck/scan/' + data.id, async () => {
							this.modelId = data.id;
							await this.getOutgoingCheck(data.id);
							this.goToNext(2);
							return;
						});
					} else {
						this.model = data;
						this.goToNext(2);
					}

					this.deliveryInstructionQrCode = '';
					//await this.setSelectedOutgoingCheck(item);
				}
			} catch(error) {
				this.deliveryInstructionQrCode = '';
				let errors = error.response.data.errors['1']
				this.toast({message: errors[0], title: 'System Error', variant: 'danger', autoHideDelay: 3000})
				this.$nextTick(() => {
					this.focusInput(this, "fieldset-delivery-instruction-number");
				});
			}
		},
		async setSelectedOutgoingCheck(item) {

			let deliveryInstructionId = item.id
			console.log("outgoingChecks", this.outgoingChecks);
			console.log("di Id", deliveryInstructionId)
			let outgoingCheck = this.outgoingChecks.find(e => e.deliveryInstructionId = deliveryInstructionId);
			console.log("selected outgoingcheck", outgoingCheck);

			let id = outgoingCheck.id;
			if(this.modelId != id) {
				console.log("different currentId: " + this.modelId + " selectedId: " + id);
				this.$router.replace('/outgoingcheck/scan/' + id, async () => {
					this.modelId = outgoingCheck.id;
					await this.getOutgoingCheck(id);
					this.goToNext(2);
					return;
				});
			}

			this.modelId = id;
			await this.getOutgoingCheck(id);
			this.goToNext(2);
		},
		pagePreview(next) {
			if(next) {
				this.scanPageIndex = this.scanPageIndex + 1;
			}
			else {
				this.scanPageIndex = this.scanPageIndex - 1;
			}
			
		},
		getOutgoingCheck : async function(id) {
			this.isBusy = true;
			return await OutgoingCheck.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();

				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});

				console.log("model on get", this.model);

				this.model.outgoingCheckDetail = this.model.outgoingCheckDetail.filter(item => !item.isCompleted);
				
				return this.model;
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadOutgoingCheck = true;
			this.filterOutgoingCheck.id = this.modelId;
			OutgoingCheck.downloadDataDetail(this, this.filterOutgoingCheck).then(result => {
				this.isDownloadOutgoingCheck = false;
			}).catch(error => { this.isDownloadOutgoingCheck = false; })
		},
		getOutgoingCheckDetails : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterOutgoingCheckDetail);
			if (this.modelId == null) return;
			filter.outgoingCheckId = this.modelId;
			filter.draftMode = "0";
			filter.isCompleted = "false"
			if (this.sortByOutgoingCheckDetail != null) {
				this.sortingByOutgoingCheckDetail[this.sortByOutgoingCheckDetail] = this.sortDescOutgoingCheckDetail;
			}
			let currentPage = (this.currentOutgoingCheckDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalOutgoingCheckDetailRow + 1;
				let page = Math.ceil(totalData/this.outgoingCheckDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.outgoingCheckDetailPageSize = 0;
			// disable paging end
			OutgoingCheckDetail.getList(this, filter, this.sortingByOutgoingCheckDetail, currentPage , this.outgoingCheckDetailPageSize).then(result => {
				this.currentOutgoingCheckDetailPage = currentPage + 1;
				this.outgoingCheckDetails = result.data;
				this.totalOutgoingCheckDetailRow = result.dataCount;
			}).catch(error => {});
		},
		getOutgoingChecks : async function(input) {
			let filter = new OutgoingCheckFilter();
			if (input != undefined) {
				filter.OutgoingCheckNumber = input;
			}

			filter.outgoingCheckStatusId = "1,2";

			this.isOutgoingCheckComboLoading = true;
			await OutgoingCheck.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.outgoingChecks = result.data
				}
				this.isOutgoingCheckComboLoading = false;
			})
			.catch(error => {});
		},
		getDeliveryInstructionDetails : async function(input) {
			let filter = new DeliveryInstructionDetailFilter();
			if (input != undefined) {
				filter.part = input;
			}
			this.isDeliveryInstructionDetailComboLoading = true;
			await DeliveryInstructionDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.deliveryInstructionDetails = result.data
				}
				this.isDeliveryInstructionDetailComboLoading = false;
			})
			.catch(error => {});
		},
		getDeliveryCards : async function(input) {
			let filter = new DeliveryInstructionDeliveryCardFilter();
			filter.deliveryInstructionDetailId = this.selectedOutgoingCheckDetail.deliveryInstructionDetailId;
			filter.controlCardStatusId = 'OK';
			await DeliveryInstructionDeliveryCard.getList(this, filter, null, null, 0)
			.then(result => {
				if (result != null) {
					this.deliveryCards = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedDeliveryInstruction(item) {
			if(item == undefined || item == null) {
				this.model.deliveryInstructionId = null;
				this.model.deliveryInstruction = null;
			} else {
				this.model.deliveryInstructionId = item.id;
				this.model.deliveryInstruction = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getUserInfos : async function(input) {
			let filter = new UserInfoFilter();
			if (input != undefined) {
				filter.firstName = input;
			}
			await UserInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.userInfos = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedProcessBy(item) {
			if(item == undefined || item == null) {
				this.model.processByUserName = null;
				this.model.processBy = null;
			} else {
				this.model.processByUserName = item.userName;
				this.model.processBy = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getOutgoingCheckStatuss : async function(input) {
			let filter = new OutgoingCheckStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			await OutgoingCheckStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.outgoingCheckStatuss = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedOutgoingCheckStatus(item) {
			if(item == undefined || item == null) {
				this.model.outgoingCheckStatusId = null;
				this.model.outgoingCheckStatus = null;
			} else {
				this.model.outgoingCheckStatusId = item.id;
				this.model.outgoingCheckStatus = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.outgoingCheckInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			if (modalEvent != undefined && modalEvent != null) {
				modalEvent.preventDefault();
			}
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					OutgoingCheck.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'outgoingcheckindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					OutgoingCheck.insertData(this, model).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'outgoingcheckindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			return Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					return OutgoingCheck.updateData(this, model, id)
					.catch((error) => {
						return this.getOutgoingCheck(id);
					});
				}
				return false;
			});
		},
		onHidden() {
			this.getOutgoingChecks();
		},
		addRowDataOutgoingCheckDetail(modalEvent, model) {
			if (model != null) {
				model.isScanned = true;
				if (model.id != null && model.id != '') {
					model.outgoingCheckId =  this.modelId;
					OutgoingCheckDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getOutgoingCheckDetails(true);
						this.isShowPopupOutgoingCheckDetail = false;
					})
				} else {
					model.outgoingCheckId =  this.modelId;
					OutgoingCheckDetail.createDataDetail(this, model)
					.then(result => {
						this.getOutgoingCheckDetails(true);
						this.isShowPopupOutgoingCheckDetail = false;
					})
				}
			}
		},
		async editRowDataOutgoingCheckDetail(id) {
			this.outgoingCheckDetailId = id;
			this.isShowPopupOutgoingCheckDetail = true; 
		},
		async deleteRowDataOutgoingCheckDetail(id) {
			OutgoingCheckDetail.deleteData(this, id).then(result => { this.getOutgoingCheckDetails(); });
		},
		async resetDataOutgoingCheckDetail() {
			this.outgoingCheckDetailId = "";
			this.isShowPopupOutgoingCheckDetail = true;
		},
		async addDataOutgoingCheckDetail() {
			OutgoingCheckDetail.createData(this, { outgoingCheckId: this.modelId })
			.then(result => {
				this.getOutgoingCheckDetails(true);
			})
		},
		async addFromClipboardOutgoingCheckDetail() {
			let names = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					names.push({ name: item, outgoingCheckId: this.modelId });
				});
				OutgoingCheckDetail.addFromClipboard(this, names).then(result => { this.getOutgoingCheckDetails() });
			});
		},
		async replaceFromClipboardOutgoingCheckDetail() {
			let names = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					names.push({ name: item, outgoingCheckId: this.modelId });
				});
				OutgoingCheckDetail.replaceFromClipboard(this, names).then(result => { this.getOutgoingCheckDetails() });
			});   
		},
		showPopupUploadOutgoingCheckDetail() {
			this.isShowPopupUploadOutgoingCheckDetail = true;
		},
		uploadDataOutgoingCheckDetail(modalEvent, newDatas) {
			this.isShowPopupUploadOutgoingCheckDetail = false; 
		},
		downloadOutgoingCheckDetail(modalEvent) {
			this.isDownloadOutgoingCheckDetail = true;
			this.filterOutgoingCheckDetail.outgoingCheckId = this.modelId;
			OutgoingCheckDetail.downloadDataDetail(this, this.filterOutgoingCheckDetail).then(result => {
				this.isDownloadOutgoingCheckDetail = false;
			}).catch(error => { this.isDownloadOutgoingCheckDetail = false; })
		},
		saveInputOutgoingCheckDetail(item) {
			if (this.outgoingChecks != null && this.outgoingChecks != undefined  && this.outgoingChecks.length > 0) {
				item.outgoingCheck = this.outgoingChecks.find(q => q.id == item.outgoingCheckId);
			}
			if (this.deliveryInstructionDetails != null && this.deliveryInstructionDetails != undefined  && this.deliveryInstructionDetails.length > 0) {
				item.deliveryInstructionDetail = this.deliveryInstructionDetails.find(q => q.id == item.deliveryInstructionDetailId);
			}
			if (this.parts != null && this.parts != undefined  && this.parts.length > 0) {
				item.part = this.parts.find(q => q.id == item.partId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					OutgoingCheckDetail.updateData(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadOutgoingCheckDetail = false; 
			this.isShowPopupOutgoingCheckDetail = false; 
			this.isShowPopUpPdf = false;
			if (modalType == 'OutgoingCheckDetail') {
				this.getOutgoingCheckDetails();
			}
			this.getOutgoingCheck(this.modal.id);
			this.deliveryInstructionQrCode = '';
			this.deliveryInstructionDetailQrCode = '';
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
		// async scanDeliveryInstruction() {
		// 	let qrCode = encodeURIComponent(this.deliveryInstructionQrCode);
		// 	let this_ = this;
		// 	delete this_.model.id;

		// 	await this.getDeliveryInstructions(qrCode).then(() => {
		// 		console.log('this.deliveryInstructions',this.deliveryInstructions)
		// 		this_.model.deliveryInstruction = this.deliveryInstructions[0];
		// 		this_.model.deliveryInstructionId = this.deliveryInstructions[0].id;
		// 		this_.model.deliveryInstructionDiNumber = this.deliveryInstruction[0].diNumber;
		// 	})
		// 	.catch(error => {
				
		// 	});

		// 	this_.$http.post('OutgoingCheck/create/', this_.model)
		// 	.then(async function(response) {
		// 		if(response != null) {
		// 			let result = response.data;
		// 			this_.goToNext(3, result);
		// 			return;
		// 		}

		// 		this_.toast({message: 'Failed to process data', title: 'Error', variant: 'danger'});
		// 	})
		// 	.catch(error => {
		// 		this_.toast({message: 'Failed to process data', title: 'Error', variant: 'danger'});
		// 	});
		// },
		checkIsDeliveryInstructionDisabled(item) {
			// TODO: put your logic here
			return false;
		},
		async scanDeliveryInstructionDetail() {
			let qrCode = encodeURIComponent(this.deliveryInstructionDetailQrCode);
			let this_ = this;
			delete this_.model.id;

			await this.getDeliveryInstructionDetails(qrCode).then(() => {
				this_.model.deliveryInstructionDetail = this.deliveryInstructionDetails[0];
				this_.model.deliveryInstructionDetailId = this.deliveryInstructionDetails[0].id;
				this_.model.deliveryInstructionDetailPart = this.deliveryInstructionDetail[0].part;
			})
			.catch(error => {
				
			});

			this_.$http.post('OutgoingCheckDetail/create/', this_.model)
			.then(async function(response) {
				if(response != null) {
					let result = response.data;
					this_.goToNext(5, result);
					return;
				}

				this_.toast({message: 'Failed to process data', title: 'Error', variant: 'danger'});
			})
			.catch(error => {
				this_.toast({message: 'Failed to process data', title: 'Error', variant: 'danger'});
			});
		},
		checkIsDeliveryInstructionDetailDisabled(item) {
			// TODO: put your logic here
			return false;
		},
		async goToNext(page, item) {
			this.scanPageIndex = page;
			if(page == 2) {
				console.log("gotonext page 2", this.model);
				await this.getParts();
				//this.getDeliveryInstructions();
				
				return;
			}

			if(page == 3) {
				await this.getDeliveryCards()
				
				return;
			}

		},
	},
	beforeMount() {
		this.filterOutgoingCheck = new OutgoingCheckFilter();
		this.filterOutgoingCheckDetail = new OutgoingCheckDetailFilter();
		this.getOutgoingChecks();
		//this.getDeliveryInstructionDetails();
		//this.getParts();
		this.getDeliveryInstructions();
		//this.getUserInfos();
		this.getOutgoingCheckStatuss();
	},
	async mounted(){
		let id = this.$route.params.id;
		if (id != '' && id != null && id != undefined) {
			this.modelId = id;
			this.getOutgoingCheck(id);
		}
		this.$nextTick(() => {
			this.getDeliveryInstructions();
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	async created() {
		this.$root.$on('navigateToScanScreen', async (idParam) => {
			// Execute gotoNext() method here
			this.modelId = idParam;
			await this.goToNext(2);
		});
	},
	computed: {
	},
	watch : {
		deliveryCards: {
			deep: true,
			handler(newVal) {
				// Check if all items are checked
				this.allChecked = newVal.every(item => item.isLoading);
				// Update buttonText accordingly
				this.buttonText = this.allChecked ? "Uncheck All" : "Check All";
			}
		},
		scanPageIndex() {
			this.hideToast();
		}
	},
}
</script>
